// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"5ef7dd67","254":"b4238517","565":"ce379418","691":"1e5e7794","716":"c06e2772","955":"08e952bb","961":"3a1cd410"}[chunkId] + ".chunk.js";
};